import React, { useState } from 'react';
import BlockContainer from './BlockContainer';
import { Textarea } from 'evergreen-ui';
import PropTypes from 'prop-types';
import AttributeAPIContainer from '../elements/AttributeAPIContainer';
import { updateOnChangeText, updateOnSelectAttribute } from './../../utils';
import locationIcon from './../../pages/builder/assets/images/icons/location.svg';
import TextCharInfo from '../elements/TextCharInfo';
import ErrorCounterInput from '../elements/ErrorCounterInput';
import SequenceSelectInput from '../elements/SequenceSelectInput';
import FailTextInput from '../elements/FailTextInput';

const LocationViberBlock = ({
  id,
  save,
  saveBlock,
  saveLoader,
  text,
  attributeList,
  apiList,
  setText,
  variable,
  sequences,
  setVariable,
  deleteBlock,
  copyBlock,
  moveBlock,
  hasWriteAccess,
  failText,
  updateBlockValue,
  errorCounter,
  failedSequenceId,
}) => {
  const [showAttribute, setShowAttribute] = useState(false);
  const [showAPI, setShowAPI] = useState(false);
  const [maxCount] = useState(320);

  return (
    <BlockContainer
      id={id}
      title='Location Input Block'
      subtitle='Add A Location Block'
      save={save}
      isLoading={saveLoader}
      icon={locationIcon}
      handleSaveClick={() => saveBlock(id)}
      handleDelete={() => deleteBlock(id)}
      sequences={sequences}
      handleCopy={copyBlock}
      handleMove={moveBlock}
      hasWriteAccess={hasWriteAccess}
    >
      <React.Fragment>
        <AttributeAPIContainer
          attributeList={attributeList}
          showAttribute={showAttribute}
          setShowAttribute={setShowAttribute}
          apiList={apiList.filter((api) => api.return_type === 'text')}
          showAPI={showAPI}
          setShowAPI={setShowAPI}
          handleSelect={(value) =>
            (text + value).length + 2 <= maxCount &&
            updateOnSelectAttribute(
              value,
              showAttribute,
              showAPI,
              setShowAttribute,
              setShowAPI,
              setText,
              text,
              apiList
            )
          }
        >
          <Textarea
            required={true}
            grammarly={true}
            spellCheck={true}
            disabled={!hasWriteAccess}
            value={text}
            className='custom-input-style'
            onChange={(e) =>
              e.target.value.length <= maxCount &&
              updateOnChangeText(
                e.target.value,
                setShowAttribute,
                setShowAPI,
                setText
              )
            }
            placeholder='Your Location block as Input'
          />
        </AttributeAPIContainer>
        <TextCharInfo data={text} count={maxCount} />
        <FailTextInput
          value={failText}
          handleChange={(value) => updateBlockValue(value, 'fail_text')}
        />
        <br />
        <br />
        <div className='flex'>
          <div className='flex-1 mr-5px'>
            <ErrorCounterInput
              value={errorCounter}
              handleChange={(value) => updateBlockValue(value, 'error_counter')}
            />
          </div>
          <div className='flex-1 ml-5px'>
            <SequenceSelectInput
              value={failedSequenceId}
              options={sequences}
              handleChange={(value) => {
                updateBlockValue(value, 'fail_sequence');
                updateBlockValue(value.id, 'fail_sequence_id');
              }}
            />
          </div>
        </div>
      </React.Fragment>
    </BlockContainer>
  );
};

LocationViberBlock.propTypes = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  setText: PropTypes.func.isRequired,
  variable: PropTypes.string.isRequired,
  setVariable: PropTypes.func.isRequired,
  save: PropTypes.bool.isRequired,
  saveBlock: PropTypes.func.isRequired,
  attributeList: PropTypes.arrayOf(PropTypes.string),
  apiList: PropTypes.arrayOf(PropTypes.object),
  saveLoader: PropTypes.bool.isRequired,
  hasWriteAccess: PropTypes.bool,
  updateBlockValue: PropTypes.func.isRequired,
  errorCounter: PropTypes.number,
  failText: PropTypes.string,
  failedSequenceId: PropTypes.object,
};

LocationViberBlock.defaultProps = {
  setVariable: (e) => console.log(e),
  hasWriteAccess: false,
};

export default LocationViberBlock;
